import { getData as apiGetData } from 'api/Api'
import {
  setLoadStatus,
  setIsCardInMyBoard,
  setMyBoard
} from '../redux/myBoard'

const getMyBoard = (cardId) => {
  return new Promise(resolve => {
    apiGetData('CardInMyBoard', { cardId }).then((data) => {
      resolve(data)
    }, () => {
      resolve(false)
    })
  })
}

type Payload = {
  cardId: number
}

export default (payload: Payload) => async dispatch => {
  const { cardId } = payload

  dispatch(setLoadStatus({
    cardId,
    isLoading: true,
    isLoaded: false
  }))

  try {
    const MyBoard: any = await getMyBoard(cardId)

    const batchedActions: any[] = [
      setLoadStatus({
        cardId,
        isLoading: false,
        isLoaded: true
      })
    ]

    if (MyBoard) {
      batchedActions.push(setIsCardInMyBoard({
        cardId,
        isCardInMyBoard: true
      }))

      batchedActions.push(setMyBoard({
        cardId,
        myBoard: {
          vCardId: MyBoard.VCardId,
          vListId: MyBoard.VListId,
          vListName: MyBoard.VListName
        }
      }))
    } else {
      batchedActions.push(setIsCardInMyBoard({
        cardId,
        isCardInMyBoard: false
      }))
    }

    dispatch(batchedActions)
  } catch (error) {
    dispatch(setLoadStatus({
      cardId,
      isLoading: false,
      isLoaded: false
    }))
  }
}
